import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox";
import Button from "../common/Button/Button";
import Fi from "../common/Field/Fi";
import { TextField, FormGroup } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import ReactCountryFlag from "react-country-flag";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function SellWithUsForm() {
  const mobMatch = useMediaQuery("(max-width:600px)");

  const [isFocused, setIsFocused] = React.useState(false);
  const [include, setInclude] = React.useState(false);
  const [also, setAlso] = React.useState(false);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [num, setNum] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [msg, setMsg] = React.useState("");
  const handleClear = () => {
    setInclude(false);
    setAlso(false);
    setName("");
    setEmail("");
    setCompany("");
    setNum("");
    setMsg("");
  };
  return (
    <>
      <>
        <Box
          sx={{
            width: { xs: "100%", sm: "694px" },
            outline: "none",
            backgroundColor: { xs: "#fff", sm: "" },
            margin: { xs: "0px 0px 16px", sm: "72px auto" },
            padding: { xs: "24px 16px", sm: "0px" },
            borderRadius: { xs: "8px", sm: 0 },
            boxShadow: {
              xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
              sm: "none",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Typography
              variant={mobMatch ? "h3" : "h2"}
              sx={{
                fontFamily: "Inter",
                fontSize: { xs: "22px", sm: "32px" },
                fontWeight: { xs: 600, sm: 700 },
                lineHeight: { xs: "26px", sm: "36px" },
                color: "text.primary",
                width: { xs: "100%", sm: "694px" },
                textAlign: { sm: "center" },
              }}
            >
              Looking to advertise more than 100 listings? Contact us to have
              customize package.
            </Typography>
          </Box>

          <Box
            sx={{
              marginTop: { xs: "16px", sm: "56px" },
              marginX: "auto",
              width: { xs: "100%", sm: "550px" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexFlow: { xs: "column", sm: "row" },
                rowGap: "26px",
                columnGap: "26px",
              }}
            >
              <Fi
                sx={{ width: { xs: "100%", sm: "262px" }, height: "46.29px" }}
                size="small"
                height="46.29px"
                label="Full Name"
                value={name}
                handleChange={(e) => setName(e.target.value)}
              />

              <Fi
                sx={{ width: { xs: "100%", sm: "262px" }, height: "46.29px" }}
                label="Email Address"
                size="small"
                height="46.29px"
                value={email}
                handleChange={(e) => setEmail(e.target.value)}
              />
            </Box>
            <Box
              sx={{
                flexFlow: { xs: "column", sm: "row" },
                rowGap: "26px",
                marginTop: "26px",
                display: "flex",
                columnGap: "26px",
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "85px",
                    height: "46.29px",
                    backgroundColor: "#F5F5F5",
                    border: "1px solid #BFBFBF",
                    borderRight: "none",
                    borderRadius: "3px 0 0 3px",
                  }}
                >
                  <ReactCountryFlag countryCode="AE" svg />
                  <Typography
                    variant="body1"
                    fontFamily="Inter"
                    fontSize="16px"
                    fontWeight="400"
                    lineHeight="24px"
                    color="primary.main"
                    sx={{ marginLeft: "5px" }}
                  >
                    +971
                  </Typography>
                </Box>
                <Fi
                  sx={{
                    width: { xs: "100%", sm: "177px" },
                    height: "46.29px",
                  }}
                  inputPropsSx={{
                    borderRadius: "0 3px 3px 0",
                  }}
                  label="Phone Number"
                  size="small"
                  height="46.29px"
                  value={num}
                  handleChange={(e) => setNum(e.target.value)}
                />
              </Box>
              <Fi
                sx={{ width: { xs: "100%", sm: "262px" }, height: "46.29px" }}
                size="small"
                height="46.29px"
                label="Company"
                value={company}
                handleChange={(e) => setCompany(e.target.value)}
              />
            </Box>
            <TextField
              multiline
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              label={
                !isFocused &&
                msg.length == 0 && (
                  <Typography
                    variant="body1"
                    fontFamily="Inter"
                    fontSize="16px"
                    fontWeight="400"
                    lineHeight="24px"
                    color="#616161"
                  >
                    Message
                  </Typography>
                )
              }
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  padding: "0px",
                },
                "& .MuiOutlinedInput-input": {
                  minHeight: "88px",
                  color: "black",
                  padding: "11px 13px",
                },
                marginTop: "26px",
              }}
            />
            <Box sx={{ marginTop: "26px" }}>
              <FormGroup
                sx={{ display: "flex", flexFlow: "column", rowGap: "8px" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={include}
                      onChange={(e) => setInclude(e.target.checked)}
                      sx={{
                        padding: "0px",
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                        color: "primary.main",
                        "&.Mui-checked": {
                          color: "primary.main",
                        },
                      }}
                    />
                  }
                  sx={{
                    margin: "0px",
                    "& .MuiTypography-root": {
                      fontSize: "14px",
                      lineHeight: "20px",
                      color: "#616161",
                      fontStyle: "normal",
                    },
                  }}
                  label="Include me on exclusive offers, giveaways, and machineryplanet.io news."
                />
              </FormGroup>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "24px",
              width: "100%",
            }}
          >
            <Button
              variant="contained"
              size="lg"
              txColor="text.primary"
              bgColor="#F9D548"
              sx={{ height: "48px", width: "160px", boxShadow: "none" }}
              onClick={() => {}}
              hoverBg="#F3C04F"
            >
              Submit Now
            </Button>
          </Box>
        </Box>
      </>
    </>
  );
}

function Heading({ text }) {
  return (
    <Typography
      variant="subtitle1"
      fontSize="22px"
      fontWeight="600"
      lineHeight="26px"
      color="text.primary"
    >
      {text}
    </Typography>
  );
}
